module.exports = __webpack_public_path__ + "static/img/linea-etica.a90051c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/linea-etica-en/linea-etica.jpg
// module id = o3KE
// module chunks = 0